import { RefObject, useLayoutEffect, useState } from 'react';

// can use one of panelId or panelRef
export function useDetectXSPanel({
  panelId,
  panelRef,
  breakpoint = 290,
}: {
  panelId: string;
  panelRef?: RefObject<HTMLDivElement>;
  breakpoint?: number;
}) {
  const [isXsPanel, setIsXsPanel] = useState(false);

  const panelRefElement = panelRef?.current;
  useLayoutEffect(() => {
    const panel = panelRefElement || document.getElementById(panelId);
    if (!panel) return;

    const handleResize = () => {
      const panelWidth = panel.offsetWidth;
      if (panelWidth) {
        setIsXsPanel(panelWidth < breakpoint);
      }
    };

    const observer = new ResizeObserver(handleResize);
    observer.observe(panel);

    return () => {
      observer.unobserve(panel);
    };
  }, [breakpoint, setIsXsPanel, panelId, panelRefElement]);

  return isXsPanel;
}
